'use strict';

angular.module('app')
    .controller('Auth0LoginController', ['$state', '$window', '$rootScope', 'RestaurantUnit', 'ConfigService', 'AUTH0_CONFIG', 
        function ($state, $window, $rootScope, RestaurantUnit, ConfigService, AUTH0_CONFIG) {


        // if we're already logged in, go home... but still redirect in case our URL is polluted
        if (ConfigService.getToken()) {
            $window.location.href = ConfigService.getCurrentRecipeViewerUrl() + 'category';
            return;
        }

        var moveToLogin = function () {
            // the way that we construct the URLs here may feel weird 
            // in non-prod environments, angularjs doesn't handle our full URLs well
            // so we have to construct them ourselves
            // ex. in staging the URL will be something along the lines of https://recipes.marginedge.com/me-19994/index.html#!/login
            // if we ask angular for an absolute URL, it will give us https://recipes.marginedge.com/#!/login
            // which is what we use in prod
            
            $rootScope.auth0Client.loginWithRedirect({
                appState: {targetUrl: ConfigService.getCurrentRecipeViewerUrl() + 'category'},
                authorizationParams: {
                    redirect_uri: ConfigService.getCurrentRecipeViewerUrl() + 'auth',
                    connection: AUTH0_CONFIG.connection,
                    audience: AUTH0_CONFIG.audience
                }
            })
                .catch(function () {
                    // something went wrong... try logging in again! (logout first)
                    ConfigService.logout();
                });
        };

        var handleAuth0Redirect = function () {
            
            $rootScope.auth0Client.handleRedirectCallback()
                .then(function (passedState) {
                    loadAndPopulateToken(_.get(passedState, 'appState.targetUrl', ''));
                })
                .catch(function () {
                    // something went wrong... try logging in again! (logout first)
                    ConfigService.logout();
                });
        };
        
        var loadTenantAndRedirect = function(redirectUrl) {
            redirectUrl = redirectUrl || $state.href('category', {id: ''}, {'absolute': true});
            RestaurantUnit.current().$promise
                .then(function (unit) {
                    ConfigService.setRestaurantUnit(unit);
                    $window.location.href = redirectUrl;
                });
        }

        var loadAndPopulateToken = function (redirectUrl) {

            $rootScope.auth0Client
                .getTokenSilently({
                    cacheMode: 'cache-only',
                    authorizationParams: {
                        audience: AUTH0_CONFIG.audience
                    }
                })
                .then(function (accessToken) {
                    ConfigService.setToken({access_token: accessToken});
                    loadTenantAndRedirect(redirectUrl);
                })
                .catch(function () {
                    // something went wrong... try logging in again! (logout first)
                    ConfigService.logout();
                });
        };

        if (location.search.includes("state=") &&
            (location.search.includes("code=") || location.search.includes("error="))) {
            handleAuth0Redirect();
        } else {
            // if we get to this page and are not authenticated in the browser, we need to log in
            // if we are already logged into auth0, this will just redirect us back to us
            moveToLogin();
        }
        
    }]);